import type { ProgramTheme } from '@/api/programs'

/**
 * Слова словаря темы — источник для заданий, которые строятся из лексики:
 * соответствия, кроссворд и тест по карточкам.
 *
 * Собираются из элементов темы: отдельного запроса за словарём темы нет, и
 * заводить его ради выпадающего списка незачем.
 */

export type ThemeWord = {
  id: number
  text: string
  translation: string | null
}

export function themeWordsOf(theme: ProgramTheme | null | undefined): ThemeWord[] {
  if (!theme?.elements) return []

  const words: ThemeWord[] = []

  for (const element of theme.elements) {
    if (element.type !== 'vocabulary') continue

    for (const word of element.words ?? []) {
      words.push({ id: word.id, text: word.text, translation: word.translation })
    }
  }

  return words
}
